export default __webpack_public_path__ + "static/media/logo.edd57611.svg";